module.exports = __webpack_public_path__ + "img/chum_yes.75c1c4dc.png";